import type { Variaveis } from './traduzir';

type Tradutor = (chave: string, variaveis?: Variaveis) => string;

/**
 * Slug estável do valor do banco, usado como chave de dicionário.
 *
 * Não dá para usar o valor cru: `t()` separa segmentos por ponto e há área com
 * ponto no nome ("28-ACAB., ESTOCAGEM E DESPACHO BOBINAS"). Tira acento, troca
 * o que não é alfanumérico por `_` e colapsa repetições.
 */
export function chaveDominio(valor: string): string {
  return valor
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toUpperCase();
}

function rotulo(t: Tradutor, ramo: string, valor: string | null | undefined): string {
  if (!valor) return '';
  const chave = `dominio.${ramo}.${chaveDominio(valor)}`;
  const traduzido = t(chave);
  // Valor que não está no mapa (status novo, área nova) mostra a si mesmo —
  // nunca a chave crua na cara do usuário.
  return traduzido === chave ? valor : traduzido;
}

/** Status do ativo (LEVANTADO, TRAMITADO, ...) — o dado segue em português. */
export function rotuloStatusAtivo(t: Tradutor, status: string | null | undefined): string {
  return rotulo(t, 'statusAtivo', status);
}

/** Área da planta (26-LAMINADOR DE TIRAS A QUENTE, ...). */
export function rotuloAreaAtivo(t: Tradutor, area: string | null | undefined): string {
  return rotulo(t, 'areaAtivo', area);
}
